<template>
    <custom-swiper>
        <template v-slot:slides>
            <div
                v-for="sticker in stickers"
                :key="sticker.code"
                :class="{ 'cz2__checkout__sticker__slide--disabled': selectedSticker === sticker.code }"
                class="swiper-slide slide-group cz2__checkout__sticker__slide"
            >
                <div
                    class="cz2__checkout__sticker__slide__image"
                    :style="{ backgroundImage: `url(${sticker.image})` }"
                />

                <div>
                    <h3 class="cz2__checkout__sticker__slide__heading">
                        {{ $t('CHECKOUT_ACCESSORIES') }}
                    </h3>

                    <h4 class="cz2__checkout__sticker__slide__title">
                        {{sticker.name}}
                    </h4>
                </div>

                <div>
                    <div class="cz2__checkout__sticker__slide__heading">
                        {{ $t('ITEM_FREE')}}
                    </div>

                    <span class="cz2__sr-only">
                        {{ $t('SR_ACTIVATING') }}
                    </span>
                    <sb-button
                        heightVariant="small"
                        v-if="isSpellingBee"
                        @click="addSticker(sticker.code)"
                        :aria-current="selectedSticker === sticker.code"
                    >
                        {{ $t('CHECKOUT_INCLUDE') }}
                    </sb-button>
                    <btn
                        v-else
                        @click="addSticker(sticker.code)"
                        :aria-current="selectedSticker === sticker.code"
                        class="cz2__checkout__sticker__slide__button swiper-button cz2__stationary-text-transform"
                    >
                        {{ $t('CHECKOUT_INCLUDE') }}
                    </btn>
                </div>
            </div>
        </template>
    </custom-swiper>
</template>

<style lang="scss">
    @import "../style/variables.scss";
    @import "../style/shared.scss";

    #cz2.cz2 {
        .cz2__checkout__carousel {
            background-image: radial-gradient(rgb(125, 184, 238) 32%, transparent 32%), radial-gradient(rgb(125, 184, 238) 32%, transparent 32%);
            background-position: 0px 0px, 52px 52px;
            background-size: 104px 104px;
            background-color: color(v2BlueLight);

            .cz2__checkout__sticker__slide.cz2__checkout__sticker__slide--disabled {
                button {
                    pointer-events: none;
                }

                opacity: 0.5;
            }

            .cz2__checkout__sticker__slide {
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                border-radius: 12px;
                padding: 16px;
                width: 200px;
                height: 350px;
                background-color: color(primaryWhite);

                color: color(textColor);

                transition: opacity .25s ease-out;

                .cz2__checkout__sticker__slide__image {
                    margin: 0 auto;

                    width: 113px;
                    height: 145px;

                    background: transparent;
                    background-repeat: no-repeat;
                    background-size: contain;
                    background-position: center;
                }

                .cz2__checkout__sticker__slide__heading {
                    @include font(bodyRegular);
                }

                .cz2__checkout__sticker__slide__title {
                    @include font(h4);
                }

                .cz2__checkout__sticker__slide__button {
                    margin-top: 12px;

                    width: 100%;

                    background-color: #F3F3F7;

                    &:focus-visible {
                        outline: none;

                        &:after {
                            content: '';
                            position: absolute;

                            left: -2px;
                            top: -2px;

                            width: 100%;
                            height: 100%;

                            border: 5px solid color(secondaryBlack);
                            border-radius: 32px;
                        }
                    }
                }

                @include respond-above(sm) {
                    .cz2__checkout__sticker__slide {
                        width: 225px;
                        height: 350px;
                    }
                }
            }
        }
    }

    #cz2.cz2__is-sb {
        .cz2__checkout__sticker__slide__button {
            display: none;
        }

        .cz2__checkout__sticker__slide__heading {
            padding-bottom: 8px;
        }
    }
</style>

<script>
    import Btn from './ui/Btn.vue';
    import SbButton from './SbButton.vue';
    import CustomSwiper from './ui/CustomSwiper.vue';

    import * as constants from '../constants';

    export default {
        components: {
            Btn,
            CustomSwiper,
            SbButton,
        },

        props: {
            stickers: {
                type: Array,
                required: true,
            },
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            selectedSticker() {
                return this.viewController.selectedAtPlacement(constants.PLACEMENT_STICKERS).code;
            },

            isSpellingBee() {
                return this.$store.state.isSpellingBee;
            },
        },

        methods: {
            addSticker(stickerCode) {
                this.$store.dispatch('log', {
                    level: 'info',
                    message: 'Add sticker',
                });

                this.$store.dispatch('log', {
                    level: 'info',
                    message: `Select sticker ${stickerCode}`,
                });

                this.viewController.updateComponent(constants.PLACEMENT_STICKERS, stickerCode);
            },
        },
    };
</script>
